<template>
  <q-page
    v-if="selectedOutcome"
    :style="cssVars"
    style="width: calc(100vw - 57px)"
  >
    <div class="q-pa-none">
      <div class="row">
        <div style="width: 100%">
          <topbar
            :title="
              currentUserData.sustainabilityBusiness_name
                ? currentUserData.sustainabilityBusiness_name
                : 'Test Business'
            "
            :titleColor="cssVars['--outcome-secondary']"
            :backgroundColor="cssVars['--outcome-primary']"
          >
            <template v-slot:content>
              <div class="row">
                <span
                  class="title"
                  :style="`color: ${cssVars['--outcome-secondary']}`"
                >
                  {{
                    currentUserData.sustainabilityBusiness_name
                      ? currentUserData.sustainabilityBusiness_name
                      : "Test Business"
                  }}
                </span>
              </div>
              <div
                class="row justify-between items-center"
                style="margin-top: -20px"
              >
                <div class="row items-center q-mt-xs">
                  <span class="dropdownTitle text-white">
                    Entering Data for
                  </span>
                  <sustainability-dropdown
                    :model="selectedOutcome"
                    class="q-ml-sm"
                    :style="`
                      background-color: ${cssVars['--outcome-secondary']};
                      border-radius: 5px;
                      `"
                    :options="outcomesList"
                    :isObjects="true"
                    objectKey="label"
                    @input="selectOutcome"
                  ></sustainability-dropdown>
                  <div class="q-ml-sm">
                    <year-picker
                      :initialYear="selectedYear"
                      ref="yearPicker"
                      label="for"
                      :bg="cssVars['--outcome-secondary']"
                      @selectYear="checkCalendar"
                    ></year-picker>
                  </div>
                </div>
                <div class="row items-center q-col-gutter-md">
                  <div class="col">
                    <q-btn
                      no-caps
                      :label="isAddingNote ? 'Cancel setting note' : 'Set note for cell'"
                      flat
                      class="text-white"
                      @click="toggleAddingNote"
                      style="background: #4AC7E9; padding: 2px 0;"
                    ></q-btn>
                  </div>
                  <div
                    class="col-auto"
                    v-if="selectedOutcome.usesFactor"
                    style="min-width: 250px; max-width: 250px"
                  >
                    <span
                      class="q-mr-sm sortLabel"
                      :style="`color: ${cssVars['--outcome-secondary']}`"
                    >
                      {{ selectedOutcome.label }} Intensity
                    </span>
                    <div class="row items-center">
                      <div class="col">
                        <q-input
                          filled
                          class="q-mr-sm bg-white"
                          style="border-radius: 5px"
                          prefix="$"
                          type="number"
                          v-model="businessExtra.annualRevenue"
                          dense
                        ></q-input>
                      </div>
                      <div class="col-auto">
                        <q-btn
                          no-caps
                          label="Save"
                          flat
                          class="text-white"
                          @click="updateAnnualRevenue"
                          :loading="updatingAnnualRevenue"
                          :style="`background: ${cssVars['--outcome-secondary']}`"
                        ></q-btn>
                      </div>
                      <div class="col-12">
                        <span
                          class="q-mr-sm hintLabel"
                          :style="`color: ${cssVars['--outcome-secondary']}`"
                        >
                          Gross Revenue for this reporting year
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="col-auto">
                    <span
                      class="q-mr-sm sortLabel"
                      :style="`color: ${cssVars['--outcome-secondary']}`"
                    >
                      Show Sources
                    </span>
                    <q-select
                      filled
                      class="q-mr-sm bg-white"
                      style="border-radius: 5px"
                      v-model="sortFilter"
                      dense
                      :options="sortFilterOptions"
                    ></q-select>
                    <span class="q-mr-sm hintLabel"> </span>
                  </div>
                </div>
              </div>
            </template>
          </topbar>
        </div>
      </div>
    </div>
    <div class="row q-pt-md">
      <div style="width: 25%">
        <q-card class="shadow-10 sustainability-card-radius full-height" flat>
          <q-card-section class="q-py-none" style="padding-top: 12px">
            <span
              class="categoryHeader"
              :style="`color:${cssVars['--outcome-secondary']}`"
            >
              CATEGORY
            </span>
          </q-card-section>
          <q-scroll-area
            style="height: calc(100vh - 285px)"
            :thumb-style="{
              background: '#162c479c',
              opacity: 1,
              width: '8px',
              height: '8px',
              borderRadius: '20px',
            }"
            :visible="true"
          >
            <q-list class="q-mt-md q-pa-md">
              <q-card
                class="categoryCard no-shadow"
                :class="{ cardSelected: selectedCategory == 'all' }"
              >
                <q-item dense @click="filterCategory('all')" clickable>
                  <div class="row justify-between items-center full-width">
                    <div class="col">
                      <span class="categoryText"> All </span>
                    </div>

                    <div class="col-shrink">
                      <span class="category-number">
                        {{ getNumberOfAllData() }}
                      </span>
                    </div>
                  </div>
                </q-item>
              </q-card>

              <q-card
                class="categoryCard no-shadow"
                :class="{
                  cardSelected:
                    typeof selectedCategory === 'object'
                      ? selectedCategory.id == category.id
                      : false,
                }"
                @click="filterCategory(category)"
                v-for="(category, i) in filteredCategories"
                :key="i"
              >
                <q-item clickable dense>
                  <div class="row justify-between items-center full-width">
                    <div class="col">
                      <span class="categoryText">
                        {{ category.name }}
                      </span>
                    </div>

                    <div class="col-shrink">
                      <span class="category-number">
                        {{
                          category != "all"
                            ? getNumberOfDataByCategory(category.id)
                            : ""
                        }}
                      </span>
                    </div>
                  </div>
                </q-item>
              </q-card>
            </q-list>
          </q-scroll-area>
        </q-card>
      </div>
      <div class="col" style="width: 75%">
        <div class="row" style="height: calc(100vh - 250px)">
          <div class="col-12">
            <q-card class="shadow-15" flat>
              <sustainability-data-table
                style="height: calc(100vh - 250px)"
                :hideBottom="true"
                separator="none"
                ref="dtable"
                :data="filteredData"
                rowKey="sources_id"
                :columns="columns"
                :stickyColumnBgColor="selectedOutcome.tertiaryColor"
                headerBgColor="white"
                @rowSelected="sourceSelected"
                @rowDoubleClick="() => {}"
                headerTextColor="black"
                :pagination="{
                  rowsPerPage: 0,
                }"
                flat
              >
                <template slot="body-cell-sourceName" slot-scope="data">
                  <q-td
                    :props="data.props"
                    style="
                      background-color: var(--outcome-tertiary);
                      position: sticky;
                      left: 0;
                      z-index: 1;
                    "
                  >
                    <div class="row justify-between items-center">
                      <div class="col-auto">
                        <q-btn
                          :icon="
                            data.props.row.starValue == 1
                              ? 'mdi-star'
                              : 'mdi-star-outline'
                          "
                          :style="`color:${cssVars['--outcome-secondary']}`"
                          @click="starSource(data.props.row)"
                          size="md"
                          class="q-pa-none"
                          flat
                          rounded
                        >
                        </q-btn>
                      </div>
                      <div class="sourceColumn-div col">
                        <span class="sourceColumn">
                          {{ data.props.row.name }}
                          {{
                            data.props.row.negativeLabel &&
                            data.props.row.negative
                              ? `(${data.props.row.negativeLabel})`
                              : data.props.row.positiveLabel &&
                                !data.props.row.negative
                              ? `(${data.props.row.positiveLabel})`
                              : ""
                          }}
                          <q-tooltip>
                            {{ data.props.row.name }}
                            {{
                              data.props.row.negativeLabel &&
                              data.props.row.negative
                                ? `(${data.props.row.negativeLabel})`
                                : data.props.row.positiveLabel &&
                                  !data.props.row.negative
                                ? `(${data.props.row.positiveLabel})`
                                : ""
                            }}
                          </q-tooltip>
                        </span>
                      </div>
                      <div
                        class="col-auto"
                        v-if="data.props.row.childSourceCount > 0"
                      >
                        <q-btn
                          @click="
                            expandedSources.includes(data.props.row.sources_id)
                              ? (expandedSources = expandedSources.filter(
                                  (e) => e != data.props.row.sources_id
                                ))
                              : expandedSources.push(data.props.row.sources_id)
                          "
                          flat
                          round
                          dense
                          :icon="
                            expandedSources.includes(data.props.row.sources_id)
                              ? 'mdi-chevron-up'
                              : 'mdi-chevron-down'
                          "
                        ></q-btn>
                      </div>
                    </div>
                  </q-td>
                </template>
                <template
                  :slot="`body-cell-${month.getFullYear()}_${month.getMonth()}`"
                  slot-scope="data"
                  v-for="(month) in displayedMonths"
                >
                  <q-td :props="data.props" v-bind:key="`${month.getFullYear()}_${month.getMonth()}`">
                    <div class="dataInput-div">
                      <div
                        class="adding-note-cell-overlay"
                        v-if="isAddingNote"
                      >
                        <q-popup-edit
                          buttons
                          v-slot="scope"
                          :value="getNoteForMonthAndYearFromRow(data.props.row, month.getMonth(), month.getFullYear())"
                          @save="(value) => handleNoteAdd(data.props.row.sources_id, month.getFullYear(), month.getMonth(), value)"
                        >
                          <q-input
                            v-model="scope.value"
                            type="textarea"
                          ></q-input>
                        </q-popup-edit>
                      </div>
                      <div>
                        {{ getValueForMonthAndYearFromRow(data.props.row, month.getMonth(), month.getFullYear()) }}
                        {{ data.props.row.unit }}
                        <div
                          v-if="getNoteForMonthAndYearFromRow(data.props.row, month.getMonth(), month.getFullYear()) !== ''"
                          style="position: absolute; right: 10%; bottom: 0; height: 100%"
                        >
                          <div class="col full-height items-center flex">
                            <q-icon name="mdi-note-outline" class="q-my-auto">
                              <q-tooltip>{{ getNoteForMonthAndYearFromRow(data.props.row, month.getMonth(), month.getFullYear()) }}</q-tooltip>
                            </q-icon>
                          </div>
                        </div>
                        <q-popup-edit
                          buttons
                          v-slot="scope"
                          :value="getValueForMonthAndYearFromRow(data.props.row, month.getMonth(), month.getFullYear())"
                          @save="(value) => updateValueForSourceGivenYearAndMonth(data.props.row.sources_id, month.getFullYear(), month.getMonth(), value)"
                        >
                          <q-input
                            v-model="scope.value"
                            type="number"
                          ></q-input>
                        </q-popup-edit>
                      </div>
                    </div>
                  </q-td>
                </template>
                <template slot="body-cell-total" slot-scope="data">
                  <q-td
                    :props="data.props"
                    style="
                      background-color: var(--outcome-tertiary);
                      position: sticky;
                      right: 0;
                      z-index: 1;
                    "
                  >
                    <div class="totalColumn-div">
                      <div class="row">
                        <div class="col">
                          <span class="sourceColumn" style="display: inline">
                            {{ data.props.row.total }}
                          </span>
                        </div>
                        <div class="col-auto">
                          <span
                            class="totalColumn-unit text-accent"
                            style="display: inline"
                          >
                            {{ data.props.row.unit }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </q-td>
                </template>
              </sustainability-data-table>
            </q-card>
          </div>
        </div>
      </div>
    </div>
    <div class="row q-px-md q-pt-sm">
      <div class="col">
        <q-btn
          class="q-px-sm q-py-xs q-mx-sm bg-primary text-white bg-secondary"
          no-caps
          flat
          @click="
            $router.push(
              `${$route.path.split('/dataUpload')[0]}/chooseAssessmentTool`
            )
          "
          v-if="$route.path.includes('/outcomePlans')"
        >
          Back
        </q-btn>
      </div>
      <div class="col">
        <q-btn
          v-if="
            selectedOutcome.usesFactor == 1 &&
            selectedOutcome.emissionCalculator == 1
          "
          class="q-px-sm q-py-xs q-mx-sm text-white outcome-theme-secondary float-right"
          @click="
            $router.push(
              `${$route.path.split('dataUpload')[0]}emissionCalculator${
                $route.path.split('dataUpload')[1]
              }`
            )
          "
          no-caps
          flat
        >
          Next
        </q-btn>
        <q-btn
          v-else-if="selectedOutcome.usesFactor == 1"
          class="q-px-sm q-py-xs q-mx-sm text-white outcome-theme-secondary float-right"
          @click="
            $router.push(
              `${$route.path.split('dataUpload')[0]}dataSummary${
                $route.path.split('dataUpload')[1]
              }`
            )
          "
          no-caps
          flat
        >
          Next
        </q-btn>
        <q-btn
          v-else
          class="q-px-sm q-py-xs q-mx-sm text-white outcome-theme-secondary float-right"
          @click="
            $router.push(
              `${$route.path.split('dataUpload')[0]}goalSummary${
                $route.path.split('dataUpload')[1]
              }`
            )
          "
          no-caps
          flat
        >
          Next
        </q-btn>
      </div>
    </div>
    <!-- </div> -->
    <q-dialog v-model="dataDialog"> </q-dialog>
  </q-page>
</template>

<script>
import { mapGetters } from "vuex";
import SustainabilityDataTable from "@/components/datatable/sustainabilityDatatable.vue";
import DataForm from "@/components/data/dataForm.vue";
import { getOutcomeImage } from "@/functions/getOutcomeImage";
import SustainabilityDropdown from "@/components/sustainabilityDropdown/sustainabilityDropdown.vue";
import Topbar from "@/components/topbar/topbar.vue";
import InputTable from "@/components/inputTable/inputTable.vue";
import moment from "moment";
import YearPicker from "@/components/generalComponents/yearPicker.vue";

export default {
  components: {
    SustainabilityDataTable,
    DataForm,
    Topbar,
    SustainabilityDropdown,
    InputTable,
    YearPicker,
  },
  mounted() {
    this.selectedYear = this.$route.params.year
      ? this.$route.params.year
      : this.$moment().format("YYYY");
    this.refreshDisplayedMonths();
    this.$router.push(
      `${this.$route.path.split("/year")[0]}/year/${this.selectedYear}`
    );
    this.$store.dispatch("outcomes/loadAll").then((e) => {
      if (this.outcomesList.length > 0) {
        this.tab = this.outcomesList[0].name;
        this.selectedOutcome = this.outcomesList.find(
          (o) => o.id == this.$route.params.outcomesID
        );
        this.$store.dispatch(
          "outcomes/categories/loadAllByOutcomesID",
          this.selectedOutcome.id
        );
        this.$store.dispatch("sources/data/loadAllByOutcomesIDAndYear", {
          sustainabilityBusinessId: this.currentUserData.sustainabilityBusiness_id,
          outcomeId: this.selectedOutcome.id,
          startingMonth: new Date(this.selectedYear, 0, 2), // Set to 2nd of month to avoid timezone issues
          finalMonth: new Date(this.selectedYear, 11, 2),
        });
      }
    });
  },
  computed: {
    ...mapGetters({
      currentUserData: "auth/currentUserData",
      outcomesList: "outcomes/list",
      outcomesCategories: "outcomes/categories/listForData",
      data: "sources/data/list",
      businessExtra: "businessExtra/data",
    }),
    console: () => console,
    formattedSelectedYear() {
      if (typeof this.selectedYear === "string") {
        return this.selectedYear.split("/")[0];
      } else {
        return this.selectedYear;
      }
    },
    cssVars() {
      let primaryColorFaded = this.selectedOutcome.primaryColor
        ? this.selectedOutcome.primaryColor.split("#")
        : ["", "162c47"];
      let primaryColorFadedString = "#" + primaryColorFaded[1] + "80";

      return {
        "--outcome-primary": this.selectedOutcome.primaryColor
          ? this.selectedOutcome.primaryColor
          : "#162c47",
        "--outcome-secondary": this.selectedOutcome.secondaryColor
          ? this.selectedOutcome.secondaryColor
          : "#162c47",
        "--outcome-tertiary": this.selectedOutcome.tertiaryColor
          ? this.selectedOutcome.tertiaryColor
          : "#162c47",
        "--outcome-primary-faded": primaryColorFadedString,
      };
    },
    columns() {
      let returnCols = [
        {
          name: "sourceName",
          label: "Source",
          align: "left",
          field: "name",
          headerTextStyle: `color:${this.cssVars["--outcome-secondary"]}!important;`,
          sticky: "left",
          style:
            "min-width: 300px;max-width: 300px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        },
      ];
      this.displayedMonths.forEach((displayedMonth) => {
        returnCols.push({
          name: `${displayedMonth.getFullYear()}_${displayedMonth.getMonth()}`,
          label: (new Intl.DateTimeFormat('default', { month: 'long'})).format(displayedMonth),
          align: "center",
          field: "unit",
          headerTextStyle: `font-family: 'Montserrat';font-style: normal;font-weight: 700;font-size: 14px;color:${this.cssVars["--outcome-secondary"]}!important;`,
          style: "min-width: 180px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        });
      });
      returnCols.push(
        {
          name: "total",
          label: "Total",
          align: "center",
          field: "total",
          headerTextStyle: `color:${this.cssVars["--outcome-secondary"]}!important;`,
          sticky: "right",
          style:
            "min-width: 200px;max-width: 200px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        }
      );
      return returnCols;
    },
    formattedDateFrom() {
      if (this.dateFrom != "") {
        return moment(this.dateFrom).format();
      } else {
        return "";
      }
    },
    filteredData() {
      let filteredData = [];
      filteredData = this.data
        .filter((e) => {
          let passed = 0;
          if (
            this.selectedCategory == "all" ||
            e.categories_id == this.selectedCategory.id
          ) {
            passed += 1;
          }

          if (this.sortFilter != "Starred Only" || e.starValue == 1) {
            passed += 1;
          }

          if (
            e.name != "Unknown Source" ||
            e.total > 0
          ) {
            passed += 1;
          }

          if (!e.parent_id || this.expandedSources.includes(e.parent_id)) {
            passed += 1;
          }

          return passed == 4;
        })
        .sort((a, b) => {
          if (!a.parent_id && !b.parent_id) {
            return a.rank > b.rank ? 1 : -1;
          }
          if (a.parent_id) {
            return 1;
          }

          if (b.parent_id) {
            return -1;
          }

          return 0;
        });

      return this.assemble(filteredData);
    },

    filteredCategories() {
      return this.outcomesCategories
        .filter((c) => c.name !== "All" && this.getNumberOfDataByCategory(c.id) !== 0)
        .sort((a, b) => (a.rank > b.rank ? 1 : -1));
    },
  },
  data: () => ({
    tab: "",

    displayedMonths: [],

    //filtering
    selectedOutcome: null,
    selectedCategory: "all",

    //dialog
    dataDialog: false,
    newData: false,
    sourceName: null,
    sourceId: null,

    //selected year
    selectedYear: null,
    yearDialog: false,

    //mode
    isLockMode: true,

    sortFilter: "Starred Only",
    sortFilterOptions: ["Starred Only", "All"],

    // Carbon Intensity
    grossRevenue: 0,

    isAddingNote: false,

    expandedSources: [],

    updatingAnnualRevenue: false,
  }),
  methods: {
    async starSource(source) {
      let result = null;
      let isRemove = false;
      if (source.starValue == 1) {
        isRemove = true;
      }
      result = await this.$store.dispatch("businessStarSources/new", {
        sources_id: source.sources_id,
        value: isRemove ? 0 : 1,
      });

      if (result.Result == "Success") {
        this.$q.notify({
          position: "top-right",
          type: "positive",
          message: result.Response.Message,
        });
        await this.$store.dispatch("sources/data/loadAllByOutcomesIDAndYear", {
          sustainabilityBusinessId: this.currentUserData.sustainabilityBusiness_id,
          outcomeId: this.selectedOutcome.id,
          startingMonth: new Date(this.selectedYear, 0, 2), // Set to 2nd of month to avoid timezone issues
          finalMonth: new Date(this.selectedYear, 11, 2),
        });
      } else {
        this.$q.notify({
          position: "top-right",
          type: "negative",
          message: "There was an Error, Please try again later",
        });
      }
    },
    getOutcomeImage: getOutcomeImage,
    refreshDisplayedMonths() {
      this.displayedMonths = [];
      for(let month = 0; month < 12; month++) {
        this.displayedMonths.push(new Date(this.selectedYear, month))
      }
    },
    checkCalendar(val) {
      this.selectedYear = val.split("/")[0];
      this.refreshDisplayedMonths();
      this.$router.push(
        `${this.$route.path.split("/year")[0]}/year/${this.selectedYear}`
      );
      this.$store.dispatch("sources/data/loadAllByOutcomesIDAndYear", {
        sustainabilityBusinessId: this.currentUserData.sustainabilityBusiness_id,
        outcomeId: this.selectedOutcome.id,
        startingMonth: new Date(this.selectedYear, 0, 2), // Set to 2nd of month to avoid timezone issues
        finalMonth: new Date(this.selectedYear, 11, 2),
      });
      this.$store.dispatch("businessExtra/load", {
        params: {
          year: this.selectedYear,
        },
      });
    },
    selectOutcome(outcome) {
      this.$router.push(
        `/${this.$route.path.split("/")[1]}/${outcome.id}/dataUpload/${
          this.$route.path.split("dataUpload/")[1]
        }`
      );

      this.selectedOutcome = { ...outcome };

      this.$store.dispatch(
        "outcomes/categories/loadAllByOutcomesID",
        this.selectedOutcome.id
      );
      this.$store.dispatch("sources/data/loadAllByOutcomesIDAndYear", {
        sustainabilityBusinessId: this.currentUserData.sustainabilityBusiness_id,
        outcomeId: this.selectedOutcome.id,
        startingMonth: new Date(this.selectedYear, 0, 2), // Set to 2nd of month to avoid timezone issues
        finalMonth: new Date(this.selectedYear, 11, 2),
      });
      this.$forceUpdate();
    },
    getNumberOfDataByCategory(categoryID) {
      if (this.sortFilter == "Starred Only") {
        return this.data.filter(
          (e) => e.categories_id == categoryID && e.starValue == 1
        ).length;
      } else {
        return this.data.filter((e) => e.categories_id == categoryID).length;
      }
    },
    getNumberOfAllData() {
      if (this.sortFilter == "Starred Only") {
        return this.data.filter((e) => e.starValue == 1).length;
      } else {
        return this.data.length;
      }
    },
    getValueForMonthAndYearFromRow(row, monthNum, yearNum) {
      let datapoints = Object.values(row["sourceDataPoints"])?.filter(dp => dp.year === yearNum && dp.month === monthNum+1);
      if(!datapoints || datapoints.length === 0) return 0;
      return datapoints[0].value;
    },
    getNoteForMonthAndYearFromRow(row, monthNum, yearNum) {
      let datapoints = Object.values(row["sourceDataPoints"])?.filter(dp => dp.year === yearNum && dp.month === monthNum+1);
      if(!datapoints || datapoints.length === 0) return "";
      return datapoints[0]?.note ?? "";
    },
    handleDoubleClick(row) {
      if (row.sourcesData_id) {
        this.$store.dispatch("sources/loadSourcesDataByID", row.sourcesData_id);
        this.newData = false;
      } else {
        this.newData = true;
      }
      this.sourceName = row.sourceName;
      this.sourceId = row.sources_id;
      this.$nextTick(() => {
        this.dataDialog = true;
      });
    },
    async updateValueForSourceGivenYearAndMonth(sourceId, yearNum, monthNum, value)
    {
      this.isLockMode = true;
      let payload = {
        yearNum: yearNum,
        sourceId: sourceId,
        monthNum: monthNum+1,
        value: value,
        sustainabilityBusinessId: this.currentUserData.sustainabilityBusiness_id,
      };
      let result = await this.$store.dispatch("sources/data/updateSingleDataPoint", payload);
      this.$store.dispatch("units/loadAll");
      if (result.result === "Success") {
        this.$q.notify({
          position: "top-right",
          type: "positive",
          message: result.message,
        });
      } else {
        this.$q.notify({
          position: "top-right",
          type: "negative",
          message: result.message,
        });
      }
      await this.$store.dispatch("sources/data/loadAllByOutcomesIDAndYear", {
        sustainabilityBusinessId: this.currentUserData.sustainabilityBusiness_id,
        outcomeId: this.selectedOutcome.id,
        startingMonth: new Date(this.selectedYear, 0, 2), // Set to 2nd of month to avoid timezone issues
        finalMonth: new Date(this.selectedYear, 11, 2),
      });
    },
    filterCategory(category) {
      this.selectedCategory = category;
    },
    sourceSelected(row) {
      this.$store.dispatch("settings/setInfoBlurb", {
        value: row.infoBlurb,
        routeNames: ["dataUpload"],
      });
    },
    async submitData(sourcesData) {
      sourcesData.date_from = moment(this.dateFrom).format("YYYY-MM-DD");
      sourcesData.date_to = moment(this.dateTo).format("YYYY-MM-DD");
      let result = null;
      if (sourcesData.total || sourcesData.unit) {
        if (isNaN(parseFloat(sourcesData.total))) {
          this.$q.notify({
            position: "top-right",
            type: "negative",
            message: "Please provide a Numerical value",
          });
          return;
        }
      }
      if (sourcesData.sourcesData_id) {
        result = await this.$store.dispatch(
          "sources/saveSourcesData",
          sourcesData
        );
      } else {
        if (sourcesData.total || sourcesData.unit) {
          result = await this.$store.dispatch(
            "sources/newSourcesData",
            sourcesData
          );
        }
      }
      if (result) {
        if (result.Result == "Success") {
          this.$q.notify({
            position: "top-right",
            type: "positive",
            message: result.Response.Message,
          });
        } else {
          this.$q.notify({
            position: "top-right",
            type: "negative",
            message: "There was an Error, Please try again later",
          });
        }
      }
    },
    async updateAnnualRevenue() {
      this.updatingAnnualRevenue = true;
      try {
        let response = await this.$store.dispatch(
          "businessExtra/saveAnnualRevenue",
          {
            id: this.businessExtra.id,
            annualRevenue: this.businessExtra.annualRevenue,
            year: this.selectedYear,
          }
        );

        this.$q.notify({
          position: "top-right",
          type: response.Result == "Success" ? "positive" : "negative",
          message:
            response.Result == "Success"
              ? response.Response.Message
              : "There was an Error, Please try again later",
        });
      } catch (error) {
        this.$q.notify({
          position: "top-right",
          type: "negative",
          message: "There was an Error, Please try again later",
        });
      }
      this.updatingAnnualRevenue = false;
    },
    toggleAddingNote() {
      this.isAddingNote = !this.isAddingNote;
      console.log("note toggled: " + this.isAddingNote)
    },
    async handleNoteAdd(sourceId, yearNum, monthNum, noteValue) {
      this.isAddingNote = false;

      let payload = {
        yearNum: yearNum,
        sourceId: sourceId,
        monthNum: monthNum+1,
        noteValue: noteValue,
        sustainabilityBusinessId: this.currentUserData.sustainabilityBusiness_id,
      };
      let result = await this.$store.dispatch("sources/data/updateSingleDataPointNote", payload);
      if (result.result === "Success") {
        this.$q.notify({
          position: "top-right",
          type: "positive",
          message: result.message,
        });
      } else {
        this.$q.notify({
          position: "top-right",
          type: "negative",
          message: result.message,
        });
      }
      await this.$store.dispatch("sources/data/loadAllByOutcomesIDAndYear", {
        sustainabilityBusinessId: this.currentUserData.sustainabilityBusiness_id,
        outcomeId: this.selectedOutcome.id,
        startingMonth: new Date(this.selectedYear, 0, 2), // Set to 2nd of month to avoid timezone issues
        finalMonth: new Date(this.selectedYear, 11, 2),
      });
    },
    assemble(arr) {
      const table = {};
      arr.forEach((el) => {
        if (el.parent_id) {
          if (!table[el.parent_id]) {
            table[el.parent_id] = [];
          }
          table[el.parent_id].push(el);
        }
      });
      const result = [];

      const constructResult = (key) => {
        if (table[key]) {
          table[key].forEach((el) => {
            result.push(el);
          });
        }
      };

      arr.forEach((el) => {
        if (!el.parent_id) {
          result.push(el);
          constructResult(el.sources_id);
        }
      });

      return result;
    },
    /**
     *
     * The array is recursively sorted by level, and each element is given the level property.
     * @param {Array} list
     * @param {Object} parent
     * @returns {Array}
     */
    recursiveArraySort(list, parent = { id: undefined, level: 0 }) {
      let result = [];

      /**
       * Get every element whose parent_id attribute matches the parent's id.
       */
      const children = list.filter(
        (item) => item.parent_id === parent.sources_id
      );

      /**
       * Set the level based on the parent level for each element identified,
       * add them to the result array, then recursively sort the children.
       */
      children.forEach((child) => {
        child.level = parent.level + 1;
        result = [...result, child, ...this.recursiveArraySort(list, child)];
      });

      return result;
    },
  },
};
</script>

<style lang="scss" scoped>
/*topbar */
.title {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 22px;
}

/*year dropdown*/
.dropdownYear {
  background-color: rgba(0, 0, 0, 0.27);
  border-radius: 5px;
  padding-top: 9px;
  padding-bottom: 9px;
  padding-left: 10px;
  padding-right: 10px;
}
.label {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 22px;
  color: white;
  margin-right: 10px;
}

.dropdownTitle {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
}

.dropdownValue {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
}

/*end of top bar css*/
.unit-input-label {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
}

.unit-input-label-bold {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: bold;
  font-size: 10px;
}
.page-title {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 29px;
  display: flex;
  align-items: center;
  letter-spacing: -0.02em;
  color: var(--outcome-secondary);
}

.set-time-period {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;

  .icon {
    color: #162c47;
    font-size: 30px;
  }

  .dateFrom {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 900;
    font-size: 12px;
    line-height: 15px;
    color: #37235f;
  }

  .to {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
    line-height: 12px;
    color: #162c47;
  }

  .dateTo {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 900;
    font-size: 12px;
    line-height: 15px;
    color: #4ac7e9;
  }
}

.categoryCard {
  margin-bottom: 20px;

  .categoryText {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    display: flex;
    align-items: center;
    letter-spacing: -0.02em;
  }
}

.categoryHeader {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  color: var(--outcome-primary);
}

.cardSelected {
  background-color: var(--outcome-primary-faded);
}

.sustainability-card-radius {
  border-radius: 10px;
}

.columnLabel {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 13px;
  text-transform: uppercase;
}

.outcome-theme-primary {
  background-color: var(--outcome-primary);
}

.outcome-theme-secondary {
  background-color: var(--outcome-secondary);
}

.set-year-text {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
}

.category-number {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;
  color: rgba(5, 0, 0, 0.5);
}

.sourceColumn-div {
  width: 170px;
  text-align: left;
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
}

.sourceColumn {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  overflow: hidden;
  color: var(--outcome-secondary);
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* number of lines to show */
  line-clamp: 2;
  -webkit-box-orient: vertical;
}

.totalColumn-unit {
  margin-left: 20px;
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
}
.totalColumn-div {
  width: 170px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: none;
  display: inline;
}

.dataInput-div {
  width: 140px;
}

.scrollbar-style::-webkit-scrollbar {
  width: 8px !important;
  height: 8px;
}
.scrollbar-style::-webkit-scrollbar-thumb {
  background: #162c479c !important;
  border-radius: 20px !important;
}

.sortLabel {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 11.6054px;
}

.hintLabel {
  font-family: "Montserrat";
  font-style: italic;
  font-weight: 500;
  font-size: 11.6054px;
}

.adding-note-cell-overlay {
  z-index: 1000;
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  opacity: 0;
}

.adding-note-cell-overlay:hover {
  opacity: 1;
  background-color: rgba(0, 255, 34, 0.15);
}

</style>
